import { createAppRequest } from '@/services/request';

const request = createAppRequest();

export interface OpenPlatformTokenResult {
  accessToken: string;
  /** Unix 时间戳（毫秒）。 */
  expiresAt: number;
}

function validateOpenPlatformToken(value: unknown): OpenPlatformTokenResult {
  if (typeof value !== 'object' || value === null || Array.isArray(value)) {
    throw new Error('开放平台 Token 响应格式无效');
  }
  const token = value as Record<string, unknown>;
  if (typeof token.accessToken !== 'string' || !token.accessToken.trim()) {
    throw new Error('开放平台 Token 响应缺少 accessToken');
  }
  if (
    typeof token.expiresAt !== 'number' ||
    !Number.isFinite(token.expiresAt) ||
    token.expiresAt <= Date.now()
  ) {
    throw new Error('开放平台 Token 已过期或过期时间无效');
  }
  return {
    accessToken: token.accessToken,
    expiresAt: token.expiresAt,
  };
}

export async function getOpenPlatformToken(
  forceRefresh = false,
): Promise<OpenPlatformTokenResult> {
  const result = await request<unknown>('/bff/open-platform/token', {
    method: 'GET',
    params: forceRefresh ? { forceRefresh: true } : undefined,
  });
  return validateOpenPlatformToken(result);
}
